export default __webpack_public_path__ + "static/step-3-a7694b6f32a88390c366346d27af03fb.svg";